import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import {
  HubConnectionBuilder,
  LogLevel,
  HttpTransportType,
} from "@microsoft/signalr";

// defaultTheme
import themes from "themes";

// project imports
import NavigationScroll from "layout/NavigationScroll";
import Loadable from "ui-component/Loadable";
import { lazy } from "react";
import MainLayout from "layout/MainLayout";
import ProtectedRoute from "component/Authentication/ProtectedRoute";
import { useEffect, useState } from "react";
// Routes
const Login = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Login3"))
);
const Signup = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Register3"))
);
const ForgotPassword = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Forgot"))
);
const CheckMail = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/checkMail"))
);
const ResetPassword = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/ResetPassword"))
);
const Nonuser = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Nonuser"))
);
const ChargingStatus = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/ChargingStatus"))
);


// Admin Routes
const DashboardAdmin = Loadable(lazy(() => import("views/dashboard/Default")));
const Register = Loadable(lazy(() => import("views/register/index")));
const Map = Loadable(lazy(() => import("views/map/index")));
const BaseReport = Loadable(lazy(()=> import("views/report/logs")));
const Users = Loadable(lazy(() => import("views/users/index")));
const Profile = Loadable(lazy(() => import("views/profile/index")));
const Privacy = Loadable(lazy(() => import("views/PrivacyPolicy/privacy")));

// Users Routes
const UserDashboard = Loadable(
  lazy(() => import("views/userDashboard/Default/index"))
);
const Locations = Loadable(lazy(() => import("views/locations/index")));
const Tariff = Loadable(lazy(() => import("views/tariff/index")));
const Wallet = Loadable(lazy(() => import("views/wallet/index")));
const LogiTest = Loadable(
  lazy(() => import("views/pages/Login Pages test/Logintest"))
);

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector((state) => state.customization);
  const [messages, setMessages] = useState([]);

  // useEffect(()=>{
  //   console.log("start soket")
  //   const connection = new HubConnectionBuilder()
  //   .withUrl("http://192.168.10.202:5000/ChatHub",{
  //     // skipNegotiation: true,
  //     // transport: HttpTransportType.WebSockets,
  //     accessTokenFactory: () => 'JWTAuthenticationHIGHsecuredPasswordVVVp1OH7Xzyr'
  // })
  //   .configureLogging(LogLevel.Information)
  //   .build();

  //    // Handle connection errors
  // connection.onclose((error) => {
  //   console.log("Connection closed: ", error);
  // });
  //   connection.on("BroadcastMessage", () => {
  //     console.log("Connection is On")
  // });
  //   connection.start().then(() => {
  //     console.log("Connection started") //this is the code ok wait
  // }).catch((err) => {
  //   console.log("error in signalR connection: ---", err)
  // });

  // // Cleanup on component unmount
  // return () => {
  //   if (connection) {
  //     connection.stop();
  //   }
  // };
  // },[])

  return (
    <StyledEngineProvider injectFirst>
      {/* <LoadScript googleMapsApiKey="AIzaSyCaa528yfP8wwL6Iq8FI7zyCH_AT_r-L-s"> */}
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
          <Routes >
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login1" element={<LogiTest />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/check-mail" element={<CheckMail/>} />
            <Route path="/resetpassword" element={<ResetPassword/>} />
            <Route path="/nonuser" element={<Nonuser/>} />
            <Route path="/policy" element={<Privacy/>} />
            <Route path="/ChargingStatus" element={<ChargingStatus/>}/>

            {/* Admin Route start */}
            <Route
              path="/admin"
              element={
                 <ProtectedRoute  roles={["Admin", "SuperAdmin"]}>
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard"  element={<DashboardAdmin />} />
              <Route path="register" element={<Register />} />
              <Route path="map" element={<Map />} />
              <Route path="report" element={<BaseReport />} />
              <Route path="users" element={<Users />} />
              <Route path="profile" element={<Profile />}  />
            </Route>
            {/* Admin Route end */}

            {/* User Route start */}
            <Route
              path="/user"
              element={
                <ProtectedRoute roles={"User"}>
                  <MainLayout />
                </ProtectedRoute>
              }
              
            >
              <Route path="dashboard" element={<UserDashboard />} />
              <Route path="wallet" element={<Wallet />} />
              <Route path="tariff" element={<Tariff />} />
              <Route path="locations" element={<Locations />} />
              <Route path="profile" element={<Profile />} />
            </Route>
            {/* User Route end */}
          </Routes>

          {/* <Routes /> */}
        </NavigationScroll>
      </ThemeProvider>
      {/* </LoadScript> */}
    </StyledEngineProvider>
  );
};

export default App;
